<template>
  <div style="text-align: center;">
    <img
      :src="require('@/assets/images/background/404.svg')"
      style="height: 300px;margin-top: 100px; margin-bottom: 80px;"
    /><br />
    <vs-button @click="relogin">Re Login</vs-button><br />
    <img
      style="
      height: 24px;
    margin-top: 70px;
    border-radius: 10px;"
      :src="require('@/assets/logo.png')"
    />
    <div class="text-center"><small>Powered By - saaslabs.in</small></div>
  </div>
</template>

<script>
import router from "../router";
export default {
  name: "PAGENOTFOUND",
  components: {},
  data() {
    return {};
  },
  methods: {
    relogin() {
      router.push("/logout");
    }
  },
};
</script>
<style scoped></style>
